export default __webpack_public_path__ + "static/media/Banner.7377ee54.jpg";